const configuration = {
  search: {
    searchable: ['account', 'pickup', 'carrier', 'profile', 'consignment'],
    isShowPeek: false,
    isAdvancedFilter: false,
    isNewSearch: true,
    resultsPerPage: 20
  },
  layout: {
    sidebar: 'floating',
    central: 'customerservice',
    cacheTime: 3,
    consignmentLinkPopoverEnabled: true,
    consignmentPagePreferences: [ 'header', 'information', 'items', 'pricing and margin', 'tracking', 'tracking errors', 'manifest pricing', 'quoted pricing' ],
    headerColour: false
  },
  dashboard: {
    'customerservice-dashboard': {
      layout: [
        { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': '91451873-deb6-4cdb-99d5-52a9c799b58e' },
        { 'x': 6, 'y': 0, 'w': 6, 'h': 11, 'i': '5043e253-e6b8-44ba-ab16-5f518fed10aa' },
        { 'x': 0, 'y': 6, 'w': 6, 'h': 11, 'i': '6e7f866b-1b50-46c3-915e-4ba32f82a09e' },
        { 'x': 6, 'y': 6, 'w': 6, 'h': 11, 'i': 'ad7c197b-cabf-46cd-96dc-a06f1b64e9a9' },
        { 'x': 0, 'y': 12, 'w': 6, 'h': 11, 'i': '30774b00-74e2-4de4-8843-3f60ab3f9386' }
      ],
      widgets: {
        '91451873-deb6-4cdb-99d5-52a9c799b58e': {
          name: 'Items',
          configuration: {
            title: 'Enquiry by staff per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'Enquiries',
            xKey: 'User Full Name',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              staffBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        '5043e253-e6b8-44ba-ab16-5f518fed10aa': {
          name: 'Items',
          configuration: {
            title: 'Enquiry by type per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'Enquiries',
            xKey: 'Enqtype Desc',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              typeBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        '6e7f866b-1b50-46c3-915e-4ba32f82a09e': {
          name: 'Items',
          configuration: {
            title: 'Enquiry by interaction per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'Enquiries',
            xKey: 'Enq Reply Desc',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              interactionBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        'ad7c197b-cabf-46cd-96dc-a06f1b64e9a9': {
          name: 'Items',
          configuration: {
            title: 'Pickups by carrier per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            top: 20,
            timeBreakDown: 'Day',
            report: 'PickupsDashboard',
            xKey: 'Carrier Name',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              carrierPickBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        '30774b00-74e2-4de4-8843-3f60ab3f9386': {
          name: 'Items',
          configuration: {
            title: 'Pickups by Top 20 customers per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            top: 20,
            timeBreakDown: 'Day',
            report: 'PickupsDashboard',
            xKey: 'Account Name',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        }
      }
    },
    'customerservice-accounts-account-dashboard': {
      layout: [
        { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': 'fcf410e2-0213-4c4b-bafa-51ca60658cbc' },
        { 'x': 6, 'y': 0, 'w': 6, 'h': 11, 'i': '8b6a9524-cc13-4b30-b643-55c52590a403' }
      ],
      widgets: {
        'fcf410e2-0213-4c4b-bafa-51ca60658cbc': {
          name: 'Items',
          configuration: {
            title: 'Enquiry by type per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'Enquiries',
            xKey: 'Enqtype Desc',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              typeBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        '8b6a9524-cc13-4b30-b643-55c52590a403': {
          name: 'Items',
          configuration: {
            title: 'Pickups by carrier per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'PickupsDashboard',
            xKey: 'Carrier Name',
            yKey: 'Count',
            params: {
              dayBreakDown: true,
              carrierPickBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        }
      }
    },
    'sales-dashboard': {
      layout: [
        { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': 'c8a78545-3918-491e-98fe-0c2967b5b24b' },
        { 'x': 6, 'y': 0, 'w': 6, 'h': 11, 'i': 'fd96ba37-63c6-4f7e-962d-a225bb989b8e' }
      ],
      widgets: {
        'c8a78545-3918-491e-98fe-0c2967b5b24b': {
          name: 'Invoice',
          configuration: {
            title: 'Invoice $ Per Week Over 1 Month',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'InvoiceSummaryDashboard',
            xKey: 'Week',
            yKey: 'Billed Price',
            params: {
              weekBreakDown: true,
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'today'
            }
          }
        },
        'fd96ba37-63c6-4f7e-962d-a225bb989b8e': {
          name: 'Billed',
          configuration: {
            title: 'Top 10 billed $ by account over 1 month',
            chartType: 'Pie',
            isResizable: true,
            top: 10,
            report: 'FreightSummaryBranch',
            xKey: 'Company',
            yKey: 'Billed Price',
            params: {
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'today',
              order: 'DESC',
              orderBy: 'billed_price'
            }
          }
        }
      }
    },
    'sales-accounts-account-dashboard': {
      layout: [
        { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': 'e63234ce-288a-42f9-b353-b743bc96d5b7' },
        { 'x': 6, 'y': 0, 'w': 6, 'h': 11, 'i': 'c457f59d-94e0-4678-8e13-fddf43934101' },
        { 'x': 0, 'y': 6, 'w': 6, 'h': 11, 'i': '5913db6a-1fab-4032-afb8-da5b41e95244' },
        { 'x': 6, 'y': 6, 'w': 6, 'h': 11, 'i': '4d653ef8-a011-4c28-9b2c-6e12b9aaef7f' },
        { 'x': 0, 'y': 12, 'w': 6, 'h': 11, 'i': 'a71dd76b-5291-4206-99b4-81d87ddbc89d' },
        { 'x': 6, 'y': 12, 'w': 6, 'h': 11, 'i': 'dd77175f-afcb-4e77-8b8e-6c54c51a456a' }
      ],
      widgets: {
        'e63234ce-288a-42f9-b353-b743bc96d5b7': {
          name: 'Items',
          configuration: {
            title: 'Billed $ By Carriers Per Week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'Carrier Name',
            yKey: 'Billed Price',
            params: {
              weekBreakDown: true,
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'today',
              carrierBreakDown: true
            }
          }
        },
        'c457f59d-94e0-4678-8e13-fddf43934101': {
          name: 'Items',
          configuration: {
            title: 'Billed $ By State Per Week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'State',
            yKey: 'Billed Price',
            params: {
              weekBreakDown: true,
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'week',
              state: true
            }
          }
        },
        '5913db6a-1fab-4032-afb8-da5b41e95244': {
          name: 'Items',
          configuration: {
            title: 'Billed $ By Zones Per Week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'Zone To',
            yKey: 'Billed Price',
            params: {
              weekBreakDown: true,
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'today',
              zone: true
            }
          }
        },
        '4d653ef8-a011-4c28-9b2c-6e12b9aaef7f': {
          name: 'Consignments',
          configuration: {
            title: 'Consignments By Carriers Per Week',
            chartType: 'Line',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'Carrier Name',
            yKey: 'Connotes',
            params: {
              weekBreakDown: true,
              dateFrom: 'month',
              dateTo: 'today',
              carrierBreakDown: true
            }
          }
        },
        'a71dd76b-5291-4206-99b4-81d87ddbc89d': {
          name: 'Consignments',
          configuration: {
            title: 'Consignments By State Per Week',
            chartType: 'Line',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'State',
            yKey: 'Connotes',
            params: {
              weekBreakDown: true,
              dateFrom: 'month',
              dateTo: 'today',
              state: true
            }
          }
        },
        'dd77175f-afcb-4e77-8b8e-6c54c51a456a': {
          name: 'Consignments',
          configuration: {
            title: 'Consignments By Zones Per Week',
            chartType: 'Line',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'Zone To',
            yKey: 'Connotes',
            params: {
              weekBreakDown: true,
              dateFrom: 'month',
              dateTo: 'today',
              zone: true
            }
          }
        }
      }
    },
    'billing-dashboard': {
      layout: [
        { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': 'a8ac96dd-28f0-462f-aa57-9e3b97918cc2' },
        { 'x': 6, 'y': 0, 'w': 6, 'h': 11, 'i': 'f40d4593-66d6-48dd-9925-186042ac47dc' },
        { 'x': 0, 'y': 6, 'w': 6, 'h': 11, 'i': 'a17dfc98-5133-40f7-b1dd-24350bb6f801' },
        { 'x': 6, 'y': 6, 'w': 6, 'h': 11, 'i': '585bd15a-18ca-4732-8706-531fba8ea956' }
      ],
      widgets: {
        'a8ac96dd-28f0-462f-aa57-9e3b97918cc2': {
          name: 'Estimated',
          configuration: {
            title: 'Estimate $ by Branch per day over 1 week',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Day',
            report: 'FreightSummaryBranch',
            xKey: 'Branch Name',
            yKey: 'Est. Price',
            params: {
              dayBreakDown: true,
              branchBreakDown: true,
              dateFrom: 'week',
              dateTo: 'today'
            }
          }
        },
        'f40d4593-66d6-48dd-9925-186042ac47dc': {
          name: 'Billed',
          configuration: {
            title: 'Billed $ by Branch per week over 1 month',
            chartType: 'Bar',
            isResizable: true,
            timeBreakDown: 'Week',
            report: 'FreightSummaryBranch',
            xKey: 'Branch Name',
            yKey: 'Billed Price',
            params: {
              weekBreakDown: true,
              branchBreakDown: true,
              dateFrom: 'month',
              dateTo: 'today'
            }
          }
        },
        'a17dfc98-5133-40f7-b1dd-24350bb6f801': {
          name: 'Billed',
          configuration: {
            title: 'Top 10 billed $ by account over 1 month',
            chartType: 'Pie',
            isResizable: true,
            top: 10,
            report: 'FreightSummaryBranch',
            xKey: 'Company',
            yKey: 'Billed Price',
            params: {
              showBilledOnly: true,
              dateFrom: 'month',
              dateTo: 'today',
              order: 'DESC',
              orderBy: 'billed_price'
            }
          }
        },
        '585bd15a-18ca-4732-8706-531fba8ea956': {
          name: 'Comparison',
          configuration: {
            title: 'Consignment comparing items',
            chartType: 'Line',
            isResizable: true,
            report: 'FreightSummaryBranch',
            xKey: 'State',
            yKey: 'Connotes',
            params: {
              dateFrom: 'month',
              dateTo: 'today',
              state: true
            },
            comparing: [
              {
                name: 'Items',
                configuration: {
                  title: 'Consignment comparing items',
                  chartType: 'Line',
                  isResizable: true,
                  report: 'FreightSummaryBranch',
                  xKey: 'State',
                  yKey: 'No Items',
                  params: {
                    dateFrom: 'month',
                    dateTo: 'today',
                    state: true
                  }
                }
              }
            ]
          }
        }
      }
    }
  }
}

export default configuration
